module.exports = __webpack_public_path__ + "img/page-bg.6a845dd6.jpg";